<script setup lang="ts">
import CatalogFilterAccordion from '~/layers/catalog/components/filter/CatalogFilterAccordion.vue'
import { type TFilterItem, TFilterItemType } from '~/layers/catalog/data/types'
import FilterItemMultiselect from '~/layers/catalog/components/filter/FilterItemMultiselect.vue'
import FilterItemRange from '~/layers/catalog/components/filter/FilterItemRange.vue'
import FilterItemMultiselectGrouped from '~/layers/catalog/components/filter/FilterItemMultiselectGrouped.vue'
import FilterItemCategory from '~/layers/catalog/components/filter/FilterItemCategory.vue'

defineProps({
  filters: {
    type: Array as PropType<TFilterItem[]>,
    required: true,
  },
})

const componentMap: Record<any, any> = {
  [TFilterItemType.Multiselect]: FilterItemMultiselect,
  [TFilterItemType.Category]: FilterItemCategory,
  [TFilterItemType.Range]: FilterItemRange,
  [TFilterItemType.MultiselectGrouped]: FilterItemMultiselectGrouped,
}

const getComponent = (type: TFilterItem['type']) => {
  return componentMap[type]
}
</script>

<template>
  <div v-for="(item, index) in filters" :key="item.code">
    <template v-if="!item.disabled">
      <CatalogFilterAccordion :filter="item" :index="index">
        <slot v-if="$slots[item.code]" :name="item.code" :filter="item"/>

        <component v-else :is="getComponent(item.type)" :filter="item" />
      </CatalogFilterAccordion>
    </template>
  </div>
</template>
